import {
  FlowPlayerConfig,
  JwHlsSource,
  JWPlayerConfig,
  JwProgressiveSource,
  PlayerTypeEnum,
} from '@src/modules/players/shared/interfaces/player-configs.interface';
import { isHls } from '@root/private/js/common/securekey/util';

declare const _playerOptions: JWPlayerConfig | FlowPlayerConfig;

/**
 * key/expire를 붙이기 전 URL 끝의 쿼리스트링 구분자를 정규화한다.
 * - 쿼리 없음      → '?' 추가
 * - 이미 '?'로 끝남 → 그대로
 * - 쿼리 있음      → '&' 추가
 */
const withQuerySeparator = (file: string) =>
  `${file}${file.endsWith('?') ? '' : file.includes('?') ? '&' : '?'}`;

export const setDrmSource = async (
  playerType: PlayerTypeEnum,
  playKey: string,
  expire: string,
) => {
  if (playerType === PlayerTypeEnum.JW) {
    const jwOptions = _playerOptions as JWPlayerConfig;
    const playlist = jwOptions.playlist[0];
    if (isHls()) {
      (playlist as JwHlsSource).file = `${withQuerySeparator(
        (playlist as JwHlsSource).file,
      )}key=${playKey}&expire=${expire}`;
    } else {
      (playlist as unknown as JwProgressiveSource).sources = (
        playlist as unknown as JwProgressiveSource
      ).sources.map((source) => ({
        ...source,
        file: `${withQuerySeparator(source.file)}key=${playKey}&expire=${expire}`,
      }));
    }
  } else {
    // flow
    const flowOptions = _playerOptions as FlowPlayerConfig;
    flowOptions.clip.sources = flowOptions.clip.sources.map((source) => ({
      ...source,
      src: `${withQuerySeparator(source.src)}key=${playKey}&expire=${expire}`,
    }));
  }
};
